import { Platform } from 'react-native';

export const isSafariOnDesktop = () => {
  if (Platform.OS !== 'web') {
    return false;
  }
  if (typeof navigator === 'undefined' || !navigator.userAgent) {
    return false;
  }

  const ua = navigator.userAgent;
  const isSafari = /^((?!chrome|android).)*safari/i.test(ua);
  const isMobile = /iPhone|iPod|Android/i.test(ua);
  const isIpadOS = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;

  return isSafari && !isMobile && !isIpadOS;
};
